import { addDefaultStaffReminders } from 'components/app/calendar/partials/mixins/remindersMixin'

export default {
  methods: {
    baseAddStaff (model, staff, withReminder = true) {
      if (model.attendees.find(item => item.id === staff.id)) {
        return
      }

      model.attendees.push(staff)
      if (model.attendees.length === 1) {
        if (this.company.appointments_color_allocation === 'STAFF') {
          model.color = staff.color
        }
        if (withReminder && model.staff_reminders.length < 1) {
          addDefaultStaffReminders(model)
        }
      }
    },
    baseRemoveStaff (model, user) {
      model.attendees.splice(model.attendees.map(item => item.id).indexOf(user.id), 1)
      if (model.attendees.length < 1) {
        model.staff_reminders = []

        if (this.company.appointments_color_allocation === 'STAFF') {
          model.color = this.company.appointments_default_color
        }
      }
    },
    baseRemoveAllExistingStaff (model) {
      model.attendees = []
      model.staff_reminders = []

      if (this.company.appointments_color_allocation === 'STAFF') {
        model.color = this.company.appointments_default_color
      }
    },
    /**
     * Check staff availability for appointment
     * Optionally pull suggestions for staff members who can be added
     * to the appointment
     * @param ids
     * @param startDate
     * @param endDate
     * @param exceptAppointmentId
     * @param timezone
     * @param suggestions
     * @returns {Promise<{suggestions: [], results: {}}>}
     */
    async baseCheckAvailability (ids, startDate, endDate, exceptAppointmentId = null, timezone = null, suggestions = false) {
      const returnPayload = {
        results: {},
        suggestions: []
      }

      const { status, payload } = await this.$post('v1/appointments/staff/availability', {
        user_ids: ids,
        start_date: this.luxon.fromSQL(startDate).set({ seconds: 0 }).toSimpleSQL(),
        end_date: this.luxon.fromSQL(endDate).set({ seconds: 0 }).toSimpleSQL(),
        except: exceptAppointmentId,
        timezone,
        suggestions
      })

      if (status === 'success') {
        returnPayload.results = payload.results instanceof Array ? {} : payload.results
        returnPayload.suggestions = payload.suggestions
      }
      return returnPayload
    }
  }
}
